import { useEffect, useState } from 'react';
import { DateUtils } from 'src/utils/date.utils';

export function useAuctionTimeRemaining(closeDate?: string): string | null {
  const [timeRemaining, setTimeRemaining] = useState(() =>
    DateUtils.timeRemaining(closeDate)
  );

  useEffect(() => {
    if (!closeDate) {
      return;
    }

    const interval = setInterval(() => {
      setTimeRemaining(DateUtils.timeRemaining(closeDate));
    }, 500);

    return () => clearInterval(interval);
  }, [closeDate]);

  return timeRemaining;
}
